import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,BulkEdit,AddListItem,
        DynamicListArea} from '../components/Common';
import {Button,Input} from '../components/Input';
import u from '../utilities/Utilities';


export default class AttendanceList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Attendance",
        permission:"attendance",
        url:"/attendance-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-attendance-entry",
        deleteURL:"/api/delete-attendance-entries",
        spreadsheetURL:"/api/generate-attendance-spreadsheet",
        overviewURL:"/api/get-all-attendance-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"attendance-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    }

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        addError:"",
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions("attendance");
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);

        this.setState({
            permissions:permissions,
            pageMenuButtons:[
              {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
              {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
              {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:(permissions.view==2)},
              {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu settings={this.settings}
                          buttons={this.state.pageMenuButtons}
                          components={this.pageComponents}
                          selected={this.state.selected}/>

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <AttendanceItem key={index}
                                                content={content}
                                                index={index}
                                                onChange={onChange}
                                                onContentChange={onContentChange}
                                                registerReference={registerRef}
                                                />
                            )
                        }
                    }
                </OverviewList>

            </AppLayout>
        )
    }
}

class AttendanceItem extends React.Component{
    render=()=>{
        const {content} = this.props;
        return (
            <div>
                <DynamicListArea listLabel={"attendance-list"}
                                 permission="attendance"
                                 content={content}
                                 onChange={this.props.onChange}
                                 index={this.props.index}
                                 />
            </div>
        )
    }
}

class AddEntry extends React.Component{
    r={};

    state={
        error:"",
        options:{},
        entryData:{},
        siteOptions:[],
        eventOptions:[],
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
    }

    componentDidMount=()=>{
        //this.getOptions();
        this.getSiteOptions();

        this.show(this.props.active);
    }

    getOptions=()=>{
        u.post({
            url:"/api/get-options",
            data:{
              keys:[
                "yesNo","attendanceType"
              ]
            },
            success:(options)=>{
                this.setState({options:options});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getSiteOptions=()=>{
        u.post({
            url:"/api/get-site-options",
            data:{},
            success:(siteOptions)=>{
                siteOptions.unshift({value:"All",label:"All"});
                this.setState({siteOptions:siteOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    getEventOptions=(siteID)=>{
        u.post({
            url:"/api/get-attendance-event-options",
            data:{
                siteID:siteID,
                status:"Valid",
                onlyDateValid:true,
            },
            success:(eventOptions)=>{
                this.setState({eventOptions:eventOptions});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onComplete=()=>{
        this.setState({
            entryData:{...this.state.entryData,nric:""},
            error:"",
        });
    };

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onChange=(value,label,index)=>{
        let entryData=this.state.entryData;
        entryData[label]=value;
        if(label=="siteID"){
            this.getEventOptions(value);
        }
        this.setState({entryData:entryData});
    }

    onValidate=(fields)=>{
        let keys = fields.map((item)=>{
          return item.field;
        });

        let data={};
        for(var i=0; i<keys.length; i++){
            if(keys[i] != "divider" && this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }

        this.r[this.props.reference].onValidated({...this.state.entryData,...data});
    }

    render=()=>{
        const {siteOptions,eventOptions,options,entryData}=this.state;

        const fields=[
            {dataType:"select",field:"siteID",label:"Site",options:siteOptions,rules:{required:true}},
            {dataType:"select",field:"eventID",label:"Event",options:eventOptions,rules:{required:true}},
            {dataType:"box",field:"nric",label:"Attendee NRIC",rules:{required:true,defaultValue:this.props.targetID},enabled:(this.props.targetID) ? false : true},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         settings={this.props.settings}
                         reference={this.props.reference}
                         onToggleForm={this.props.onToggleForm}
                         onComplete={this.onComplete}
                         onCancel={this.onCancel}
                         stepScroll={true}
                         inList={this.props.miniList}
                         closeButton={"Repeat"}
                         repeat={true}
                         >

                <div>
                    <h3>Fill in the following to manually create entry</h3>
                    {
                        fields.map(
                            (item,index)=>{
                                return (
                                    <Input ref={(ref)=>{this.r[item.field]=ref}}
                                           key={index}
                                           fields={{
                                             ...item,
                                             onChange:this.onChange
                                           }}
                                           content={entryData}
                                           />
                                )
                            }
                        )
                    }
                </div>

                <div className='segment-note' style={{margin:"30px auto 0 auto"}}>Note. This function works similar to the scanning feature on mobile app</div>

                <div className="segment-buttons">
                    <div className="segment-error">{this.state.error}</div>
                    <Button onClick={this.onCancel}>Cancel</Button>
                    <Button onClick={()=>{this.onValidate(fields)}}>Confirm</Button>
                </div>

           </AddListItem>
        )
    }
}

export class MiniAttendanceList extends React.Component{
    r={};

    settings={
        title:"Attendance",
        permission:"attendance",
        url:"/attendance-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-attendance-entry",
        deleteURL:"/api/delete-attendance-entries",
        spreadsheetURL:"/api/generate-attendance-spreadsheet",
        overviewURL:"/api/get-all-attendance-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"attendance-list",
        orderByField:"createdOn",
        orderByType:"descending",
    };

    refresh=()=>{
        this.r['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref={(ref)=>{this.r["list"]=ref}}
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
                      addComponent={AddEntry}
                      addProps={this.props.addProps}
                      />
        )
    }
}